import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import * as _ from 'lodash';

@Component({
  selector: 'json-boolean',
  templateUrl: './json-boolean.component.html',
  styleUrls: ['./json-boolean.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => JsonBooleanComponent),
      multi: true,
    },
  ],
})
export class JsonBooleanComponent implements ControlValueAccessor {
  onChange: (_: any) => void = (_: any) => {};

  @Input() public disabled: boolean;
  @Input() public path: string;

  value: boolean;
  json: any;

  constructor() {}
  writeValue(obj: any): void {
    this.value = _.get(obj, this.path, false);
    this.json = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {}

  toggle() {
    this.value = !this.value;

    const change = _.set({}, this.path, this.value);
    this.json = _.merge(this.json, change);

    this.onChange(this.json);
  }
}
